module.exports = __webpack_public_path__ + "img/222A1588.a1b5249f.jpg";